import type {
  NotificationBroadcastJobModuleCompletedPayload,
  NotificationBroadcastJobModuleFailedPayload,
  NotificationBroadcastJobModulePayloadBase,
  NotificationBroadcastJobModuleRunningPayload,
} from "../notification-broadcast.type";
import type { JobModuleSubject } from "@/entities/job-module";

import { isValidObject } from "@/utilities/object";

import { NOTIFICATION_BROADCAST_TYPE } from "../notification-broadcast.enum";
import { isValidNotificationBroadcastBase } from "../notification-broadcast.helper";

export const isNotificationBroadcastJobModuleSubjects = (
  subjects: unknown
): subjects is JobModuleSubject[] =>
  Array.isArray(subjects) &&
  subjects.every(isValidObject) &&
  subjects.every(
    (subject) => "id" in subject && typeof subject.id === "number"
  ) &&
  subjects.every(
    (subject) => "name" in subject && typeof subject.name === "string"
  ) &&
  subjects.every(
    (subject) => "type" in subject && typeof subject.type === "string"
  );

export const isNotificationBroadcastJobModulePayload = (
  payload: unknown
): payload is NotificationBroadcastJobModulePayloadBase =>
  isValidNotificationBroadcastBase(payload) &&
  "job_module" in payload &&
  isValidObject(payload.job_module) &&
  "id" in payload.job_module &&
  typeof payload.job_module.id === "number" &&
  "module_name" in payload.job_module &&
  typeof payload.job_module.module_name === "string" &&
  "subjects" in payload.job_module &&
  isNotificationBroadcastJobModuleSubjects(payload.job_module.subjects);

export const isNotificationBroadcastJobModuleRunningPayload = (
  payload: unknown
): payload is NotificationBroadcastJobModuleRunningPayload =>
  isNotificationBroadcastJobModulePayload(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.JOB_MODULE_RUNNING;

export const isNotificationBroadcastJobModuleCompletedPayload = (
  payload: unknown
): payload is NotificationBroadcastJobModuleCompletedPayload =>
  isNotificationBroadcastJobModulePayload(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.JOB_MODULE_COMPLETED;

export const isNotificationBroadcastJobModuleFailedPayload = (
  payload: unknown
): payload is NotificationBroadcastJobModuleFailedPayload =>
  isNotificationBroadcastJobModulePayload(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.JOB_MODULE_FAILED;
